import React from 'react';
import './GetAppButton.scss';

const GetAppButton = ({ isBox = false }) => {
  const handleGetAppClick = () => {
    window.location.href = 'https://windcreekcasino.com/get-app';
  };

  return (
    <div className={`cv-get-app-button ${isBox ? 'box' : ''}`}>
      <button type="button" onClick={handleGetAppClick}>
        Get App
      </button>
    </div>
  );
};

export default GetAppButton;
